// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"2545d0ca","97":"6bd97e3f","205":"05b09bad","336":"dbbcd5b2","384":"a768929d","445":"a65906dd","480":"e9476a80","724":"07768765"}[chunkId] + ".chunk.js";
};